import React, { useMemo } from "react";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import "../style/maincontent.css";

const muiFilter = createFilterOptions({
  matchFrom: "any",
  stringify: (option) =>
    typeof option === "string"
      ? option
      : option?.label || option?.name || "",
});

// Common responsive width for dropdowns
const fixedAutoSX = {
  width: { xs: "100%", sm: 220 },
  "& .MuiInputBase-input": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};

const FilterBar = ({
  filters,
  filterOptions,
  onFilterChange,
  onClear,
}) => {
  const queryOptions = useMemo(() => {
    const arr = filterOptions?.query || [];
    return arr.map((o) =>
      typeof o === "string" ? o : o.label ?? o.name ?? String(o)
    );
  }, [filterOptions]);

  return (
    <div className="filters-section">
      <div className="filters-controls">
        <span className="filters-icon">
          
        </span>

        {/* 🔍 Global Search */}
        <Autocomplete
          freeSolo
          openOnFocus
          clearOnEscape
          options={queryOptions}
          inputValue={filters.query ?? ""}
          onInputChange={(e, v) => onFilterChange("query", v ?? "")}
          filterOptions={(options, state) => muiFilter(options, state)}
          sx={{
            width: { xs: "100%", sm: 220 },
            flexShrink: 1,
            "& input": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="🔍 Search"
              size="small"
              placeholder="🔍 Search..."
            />
          )}
        />

        {/* 🎛 Searchable Filters */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems={{ xs: "stretch", sm: "center" }}
          flexWrap="wrap"
          sx={{ flex: 1, minWidth: 0 }}
        >
          {/* Year */}
          <Autocomplete
            options={filterOptions.years}
            value={filters.year || null}
            onChange={(e, v) => onFilterChange("year", v || "")}
            filterOptions={muiFilter}
            sx={{
              width: { xs: "100%", sm: 120 },
              flexShrink: 1,
              "& .MuiInputBase-input": {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            }}
            renderInput={(params) => (
              <TextField {...params} label="Year" size="small" />
            )}
          />

          {/* Category */}
          <Autocomplete
            options={filterOptions.category}
            value={filters.category || null}
            onChange={(e, v) => onFilterChange("category", v || "")}
            filterOptions={muiFilter}
            sx={fixedAutoSX}
            renderInput={(params) => (
              <TextField {...params} label="Category" size="small" />
            )}
          />

          {/* Subcategory */}
          <Autocomplete
            options={filterOptions.subcategory}
            value={filters.subcategory || null}
            onChange={(e, v) => onFilterChange("subcategory", v || "")}
            filterOptions={muiFilter}
            sx={fixedAutoSX}
            renderInput={(params) => (
              <TextField {...params} label="Subcategory" size="small" />
            )}
          />

          {/* Author */}
          <Autocomplete
            options={filterOptions.authors}
            value={filters.author || null}
            onChange={(e, v) => onFilterChange("author", v || "")}
            filterOptions={muiFilter}
            sx={fixedAutoSX}
            renderInput={(params) => (
              <TextField {...params} label="Author" size="small" />
            )}
          />

          <button onClick={onClear} className="clear-filters-btn">
            Clear
          </button>
        </Stack>
      </div>
    </div>
  );
};

export default FilterBar;
